module.exports = __webpack_public_path__ + "static/media/b2-entranc.cf2f6c0f.webp";